const insertToArrayIndex = (array, index, ...elements) => {
  array.splice(index, 0, ...elements);
};

export default insertToArrayIndex;
